/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedSchoolEducationLevelDropdown200,
  GetApiV1PersonSharedSchoolEducationLevelDropdown401,
  GetApiV1PersonSharedSchoolEducationLevelDropdown500,
  GetApiV1PersonSharedSchoolEducationLevelDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedSchoolEducationLevelDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedSchoolEducationLevelDropdown200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1PersonSharedSchoolEducationLevelDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedSchoolEducationLevelDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedSchoolEducationLevelDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedSchoolEducationLevelDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedSchoolEducationLevelDropdown500>;

export const getApiV1PersonSharedSchoolEducationLevelDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedSchoolEducationLevelDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedSchoolEducationLevelDropdownQueryResponse>;
